import React from 'react';
import { motion } from 'framer-motion';
import { Info } from 'lucide-react';
export function DidYouKnow() {
  const facts = ['60% aller Hunde leiden gelegentlich unter Blähungen', 'Die meisten Blähungen entstehen durch eine unausgeglichene Darmflora', 'Präbiotika können die Gasbildung im Darm nachweislich reduzieren'];
  return <section className="w-full py-16 bg-brown/5 px-4" data-id="element-78">
      <div className="max-w-4xl mx-auto" data-id="element-79">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-80">
          <h2 className="font-handwriting text-4xl text-brown font-bold flex items-center justify-center gap-3" data-id="element-81">
            <Info className="w-8 h-8" data-id="element-82" />
            Wusstest du das?
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-83">
          {facts.map((fact, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.15
        }} className="bg-white p-6 rounded-2xl shadow-sm border-t-4 border-brown text-center flex items-center justify-center min-h-[120px]" data-id="element-84">
              <p className="font-serif text-gray-800 font-medium" data-id="element-85">{fact}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}